export default __webpack_public_path__ + "40b030131c12d4f84925d9c2283d724a.png";